import styled from 'styled-components';

export const StyledAnimatedStars = styled.div`
  position: fixed;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 20000;
`;

export const StyledStar = styled.div`
  position: absolute;
  top: ${({ pos }) => (pos ? pos.y : 0)}px;
  left: ${({ pos }) => (pos ? pos.x : 0)}px;
  opacity: ${({ animating }) => (animating ? 1 : 0)};
  pointer-events: none;
`;
